import style from "../css/modal.module.css";
import { ViewModal, ApproveModal } from ".";
import { useQuery } from "@tanstack/react-query";
import apiCall from "../../../../utils/apiCall";
import { CircularProgress } from "@mui/material";

interface ApprovalHistory {
  ActionTypeId: number;
  RouteId: number;
  AppMemberId: string;
  TargetedMembers?: any;
  TargetedMembersId: number;
  ApprovalRoleId: string;
  Email: string;
  ApprovalIndex: number;
  Status: number;
  FinalApproval: number;
  ApprovalComment: string;
  ApprovalActionTypes: number;
  ApprovalAction: string;
  ApprovalActionTypeId?: any;
  examId?: number;
}

const Modal = (props: any) => {
  const showModal: any = props.showModal;
  const modalView = props.modalView;
  const data = props.data;
  const onChange = props.setShowModal;
  const entryLevelData = props?.entryLevelData;

  const getAllApprovalHistory = async (): Promise<ApprovalHistory[]> => {
    return (
      await apiCall().get(
        `/Approval/ApprovalHistory?RouteId=1&membershipTypeId=1&ActionId=1&ApplicantId=${data?.AppMemberId}`
      )
    ).data;
  };

  const ApprovalHistoryQuery = useQuery(
    ["get-approval-History-Data", data?.AppMemberId, data?.ApprovalRoleId],
    getAllApprovalHistory,
    { refetchOnWindowFocus: false }
  );

  return (
    <>
      {showModal && (
        <div className={style.container}>
          {showModal ? (
            modalView == "view" ? (
              <ViewModal data={data} onChange={onChange} />
            ) : ApprovalHistoryQuery.isFetching ? (
              <CircularProgress
                sx={{
                  fontSize: "1rem",
                  marginInline: "auto",
                  display: "block",
                  marginBlock: "2rem",
                }}
              />
            ) : (
              <ApproveModal
                data={data}
                onChange={onChange}
                entryLevelData={entryLevelData}
                isLoading={ApprovalHistoryQuery.isFetching}
                ApprovalHistoryData={ApprovalHistoryQuery?.data}
              />
            )
          ) : (
            <></>
          )}
          <div onClick={() => onChange(false)} className={style.backDrop}></div>
        </div>
      )}
    </>
  );
};

export default Modal;
export { default as ApproveModal } from "./Approve";
export { default as ViewModal } from "./ViewDetails";
